import isEmpty from "lodash/isEmpty";
import isNumber from "lodash/isNumber";

export const checkCondition = <T, O, W>(
  condition: T,
  valueOne: O,
  valueTwo: W,
): O | W => (condition ? valueOne : valueTwo);

export const checkEmptyString = (
  str: string | undefined,
  returnFormat = "",
) => {
  return checkCondition(!isEmpty(str), `${str}`, returnFormat);
};

export const checkEmptyUndefined = (
  str: string | undefined,
): string | undefined => {
  return checkCondition(!isEmpty(str), `${str}`, undefined);
};

export const checkEmptyNumber = (num: number | undefined) => {
  return checkCondition(!isNumber(num), num, undefined);
};

export const checkEmptyArray = <T>(arr: T[] | undefined): T[] => {
  return Array.isArray(arr) ? arr : [];
};

export const checkErrorMessage = (error: unknown): string => {
  return error instanceof Error ? error.message : `${error}`;
};
